import axios from "axios";
import { getAuthInfo } from "./axios-api.helpers";

export const SERVER_API_BASE_URL = process.env["REACT_APP_SERVER_BASE_URL"];

export const axios_api = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL"],
});
let isAlert = false;

const logoutUser = () => {
  // Perform any necessary cleanup tasks, e.g., clearing local storage
  localStorage.clear();
  isAlert = true;
  // Redirect to the login page or perform any other required action
  window.alert(
    "Attention: Your session has expired. Please log in again to continue accessing the system. Thank you!",
  );
  window.location.href = "/auth/login"; // Replace with your desired logout destination
};

axios_api.interceptors.request.use((config) => {
  const accessToken = getAuthInfo();
  if (accessToken && config.headers) {
    config.headers["auth-Token"] = `${accessToken}`;
  }
  return config;
});

axios_api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!isAlert) {
        logoutUser();
      }
    }

    return Promise.reject(error);
  },
);
